import { Component } from '@angular/core';
import { CurrentUserQuery, LogbookEntriesExportGQL, LogbookEntriesFieldsFragment, LogbookEntriesGQL, LogbookEntriesQuery, LogbookEntryOrderByKey } from '../../graphql/gql';
import { ColumnDefinition } from 'src/app/paginated-table/paginated-table.component';
import { GraphQLError } from "graphql/index";
import { DataMapperResult } from 'src/app/paginated-table/table-data-source';

/**
 * Represents the LogbookEntriesComponent class.
 *
 * @class
 */
@Component({
  selector: 'app-logbook-entries',
  templateUrl: './logbook-entries.component.html',
  styleUrls: ['./logbook-entries.component.css'],
  standalone: false
})

export class LogbookEntriesComponent {
  loading = true;
  data!: CurrentUserQuery;
  errors: readonly GraphQLError[] | undefined;

  /**
   * A data structure storing attribute name, label and sorting order for each column.
   */
  columns: ColumnDefinition[] = [
    {
      attr: 'createdAt',
      label: $localize`:logbook|Created at column header:Created at`,
      orderKey: LogbookEntryOrderByKey.CreatedAt
    },
    {
      attr: 'event',
      label: $localize`:logbook|Event column header:Event`,
      orderKey: LogbookEntryOrderByKey.Event
    },
    {
      attr: 'thingType',
      label: $localize`:logbook|Object type column header:Object`,
      orderKey: LogbookEntryOrderByKey.ThingType
    },
    {
      attr: 'objectName',
      label: $localize`:logbook|Object name column header:Object name`,
      orderKey: LogbookEntryOrderByKey.ObjectName
    },
    {
      attr: 'ipAddress',
      label: $localize`:logbook|IP address column header:IP address`,
      orderKey: LogbookEntryOrderByKey.IpAddress
    },
    {
      attr: 'owner.clientNumber',
      label: $localize`:logbook|Account client number column header:Account: Client number`,
      orderKey: LogbookEntryOrderByKey.ClientNumber
    },
    {
      attr: 'owner.company',
      label: $localize`:logbook|Account organization column header:Account: Organization`,
      orderKey: LogbookEntryOrderByKey.Company
    }
  ]
  
  selectAll: boolean = false;
  selection: LogbookEntriesFieldsFragment[] = [];
  orderBy: { key: LogbookEntryOrderByKey; asc: boolean; } | null = { key: LogbookEntryOrderByKey.CreatedAt, asc: false }

  constructor(
    public logbookEntriesGQL: LogbookEntriesGQL,
    private logbookEntriesExportGQL: LogbookEntriesExportGQL) {}


  dataMapper(data: LogbookEntriesQuery): DataMapperResult<LogbookEntriesFieldsFragment> {
    return {
      items: data.logbookEntries!.edges!.map(edge => edge!.node!),
      totalCount: data.logbookEntries!.totalCount || null
    }
  }

  /**
   * Handles the click event of a logbook entry.
   *
   * @param {any} logbookEntry - The logbook entry associated with the click event.
   *
   * @return {void}
   */
  onLogbookEntryClick(logbookEntry: any): void {
    console.log(logbookEntry)
  }

  onSelectAllChange(selectAll: boolean) {
    this.selectAll = selectAll
  }

  onOrderByChange(orderBy: { key: LogbookEntryOrderByKey; asc: boolean; } | null) {
    this.orderBy = orderBy
  }

  onSelectionChange(selection: LogbookEntriesFieldsFragment[]) {
    this.selection = selection
  }

  onExportClick() {
    this.logbookEntriesExportGQL.fetch({
      ids: (this.selectAll || this.selection.length == 0) ? null : this.selection.map(o => o.id),
      orderBy: this.orderBy,
    }).subscribe({
      next: (response) => {
        const csvData = response.data.logbookEntriesExport
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'logbook_entries_export.csv'
        a.click()
        a.remove()
        URL.revokeObjectURL(url)
      }
    });
  }
}
